const RELOADED_AT_KEY = "staleChunkReloadedAt";
const RELOAD_COOLDOWN_MS = 10_000;

/**
 * A deploy replaces the hashed chunks, so a tab opened on the previous build
 * lazy-loads a chunk that no longer exists. The host answers with index.html,
 * the import fails, and the error boundary shows. Reload once to pick up the
 * new build; the cooldown stops a loop when the chunk is missing for real.
 */
export function reloadOnStaleChunk(): void {
  window.addEventListener("vite:preloadError", () => {
    let reloadedAt = 0;
    try {
      reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY)) || 0;
    } catch {
      return;
    }
    if (Date.now() - reloadedAt < RELOAD_COOLDOWN_MS) return;
    try {
      sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    } catch {
      return;
    }
    window.location.reload();
  });
}
